import { Injectable, Inject, InjectionToken } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CacheRequestServiceBase } from './request-cache.service';

@Injectable({
  providedIn: 'root'
})
export class CachingInterceptor implements HttpInterceptor {
  constructor(
    private cacheService: CacheRequestServiceBase) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.cacheService.isCachable(req)) {
      const cachedResponse = this.cacheService.get(req);
      return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.cacheService);
    }
    return next.handle(req);
  }

  sendRequest(req: HttpRequest<any>, next: HttpHandler, cacheService: CacheRequestServiceBase): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        // There may be other events besides the response.
        if (event instanceof HttpResponse) {
          cacheService.put(req, event); // Update the cache.
        }
      })
    );
  }
}
